import { render, staticRenderFns } from "./OrderXq.vue?vue&type=template&id=7ab9c7de&scoped=true&"
import script from "./OrderXq.vue?vue&type=script&lang=js&"
export * from "./OrderXq.vue?vue&type=script&lang=js&"
import style0 from "./OrderXq.vue?vue&type=style&index=0&id=7ab9c7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab9c7de",
  null
  
)

export default component.exports